/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Cli_Developer_SelectionInputs */

const en_options_cli_developer_selection = /** @type {(inputs: Options_Cli_Developer_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Developer Selection`)
};

const fr_options_cli_developer_selection = /** @type {(inputs: Options_Cli_Developer_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélection du développeur`)
};

const de_options_cli_developer_selection = /** @type {(inputs: Options_Cli_Developer_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwicklerauswahl`)
};

const it_options_cli_developer_selection = /** @type {(inputs: Options_Cli_Developer_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selezione dello sviluppatore`)
};

const ru_options_cli_developer_selection = /** @type {(inputs: Options_Cli_Developer_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбор разработчика`)
};

const es_options_cli_developer_selection = /** @type {(inputs: Options_Cli_Developer_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selección de desarrolladores`)
};

const zh_cn2_options_cli_developer_selection = /** @type {(inputs: Options_Cli_Developer_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开发商选择`)
};

const ja_options_cli_developer_selection = /** @type {(inputs: Options_Cli_Developer_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開発者の選択`)
};

const hi_options_cli_developer_selection = /** @type {(inputs: Options_Cli_Developer_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डेवलपर चयन`)
};

const pt_pt2_options_cli_developer_selection = /** @type {(inputs: Options_Cli_Developer_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleção do desenvolvedor`)
};

/**
* | output |
* | --- |
* | "Developer Selection" |
*
* @param {Options_Cli_Developer_SelectionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_cli_developer_selection = /** @type {((inputs?: Options_Cli_Developer_SelectionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Cli_Developer_SelectionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_cli_developer_selection(inputs)
	if (locale === "de") return de_options_cli_developer_selection(inputs)
	if (locale === "it") return it_options_cli_developer_selection(inputs)
	if (locale === "ru") return ru_options_cli_developer_selection(inputs)
	if (locale === "es") return es_options_cli_developer_selection(inputs)
	if (locale === "zh-CN") return zh_cn2_options_cli_developer_selection(inputs)
	if (locale === "ja") return ja_options_cli_developer_selection(inputs)
	if (locale === "hi") return hi_options_cli_developer_selection(inputs)
	if (locale === "pt-PT") return pt_pt2_options_cli_developer_selection(inputs)
	return en_options_cli_developer_selection(inputs)
});